import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import LogoComponent from '../subComponents/LogoComponent';
import PowerButton from '../subComponents/PowerButton';
import SocialIcons from '../subComponents/SocialIcons';
import { YinYang } from './AllSvgs';
import Intro from './Intro';
import Nav from '../subComponents/Nav';

const MainContainer = styled.div`
  background-image: radial-gradient(
    circle,
    #d1a96b,
    #d4b883,
    #d9c79b,
    #ded5b5,
    #e6e3cf,
    #e6e0c8,
    #e7ddc2,
    #e9dabb,
    #ebc296,
    #f2a67a,
    #f8856c,
    #fb5f6d
  );
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;

  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Karla', sans-serif;
    font-weight: 500;
  }
`;

const Container = styled.div`
  padding: 2rem;
`;



const rotate = keyframes`
  from { transform: rotate(0); }
  to { transform: rotate(360deg); }
`;

const Center = styled.button`
  position: absolute;
  top: ${(props) => (props.click ? '85%' : '50%')};
  left: ${(props) => (props.click ? '92%' : '50%')};
  transform: translate(-50%, -50%);
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 1s ease;

  & > :first-child {
    animation: ${rotate} infinite 1.5s linear;
    transition: all 0.3s ease;
  }

  &:hover > :first-child {
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
    transform: scale(1.05);
  }

  & > :last-child {
    display: ${(props) => (props.click ? 'none' : 'inline-block')};
    padding-top: 1rem;
    transition: all 0.3s ease;
  }

  &:hover > :last-child {
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
  }

  @media (max-width: 768px) {
    top: ${(props) => (props.click ? '90%' : '50%')};
    left: ${(props) => (props.click ? '90%' : '50%')};
    width: ${(props) => (props.click ? '80px' : '150px')};
    height: ${(props) => (props.click ? '80px' : '150px')};
  }
`;

const DarkDiv = styled.div`
  position: absolute;
  top: 0;
  background-color: #000;
  bottom: 0;
  right: 50%;
  width: ${(props) => (props.click ? '50%' : '0%')};
  height: ${(props) => (props.click ? '100%' : '0%')};
  z-index: 1;
  transition: height 0.5s ease, width 1s ease 0.5s;

  @media (max-width: 768px) {
    right: 0;
    width: ${(props) => (props.click ? '100%' : '0%')};
    height: ${(props) => (props.click ? '50%' : '0%')};
  }
`;

const Main = () => {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  return (
    <MainContainer>
      <DarkDiv click={click} />
      <Container>
        <PowerButton />
        <LogoComponent theme={click ? 'dark' : 'light'} />
        <SocialIcons theme={click ? 'dark' : 'light'} />

        <Center click={click}>
          <YinYang
            onClick={() => handleClick()}
            width={click ? 120 : 200}
            height={click ? 120 : 200}
            fill="currentColor"
          />
          <span>click here</span>
        </Center>

        {/* Nav Bar */}
        <Nav />
      </Container>
      {click ? <Intro click={click} /> : null}
    </MainContainer>
  );
};

export default Main;
